import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import { EditorState } from 'draft-js'

import convertToHTML from '~/components/common/inputs/rich-edit/convertToHTML'
import RichEdit from '~/components/common/inputs/rich-edit/RichEdit'

const StyledRichEdit = styled(RichEdit)`
  font-size: 14px;
`

interface QuestionTextFieldProps {
  disabled: boolean
  initialText: string
  onUpdate: (html: string) => void
  placeholder: string
}

const QuestionTextField = ({
  initialText,
  placeholder,
  disabled,
  onUpdate,
}: QuestionTextFieldProps) => {
  // eslint-disable-next-line react/hook-use-state
  const [initialHTML] = useState(initialText)
  const [editorState, setEditorState] = useState<EditorState>(
    EditorState.createEmpty(),
  )

  const handleSetEditorState = (newState: EditorState) => {
    setEditorState(newState)
    onUpdate(convertToHTML(newState))
  }

  return (
    <StyledRichEdit
      disabled={disabled}
      editorState={editorState}
      initialHTML={initialHTML}
      minEditorHeight={100}
      placeholder={placeholder}
      setEditorState={handleSetEditorState}
      showButtons={false}
      showCheckList={false}
      showSignature={false}
    />
  )
}

export default QuestionTextField
